//组件引用
import mcBtn from './components/base-btn';
import mcBtnDropdown from './components/base-btn-dropdown';
import mcBtnDropdownItem from './components/base-btn-dropdown-item';
import mcInput from './components/base-input';
import mcSwitch from './components/base-switch';
import mcScroll from './components/base-scroll';
import mcSelect from './components/base-select';
import mcSelectOption from './components/base-select-option';
import mcSelectGroup from './components/base-select-group';
import mcSelectFooter from './components/base-select-footer';
import mcSelectbox from './components/base-selectbox';
import mcSelectboxTabs from './components/base-selectbox-tabs';
import mcSelectboxPane from './components/base-selectbox-pane';
import mcSelectboxItem from './components/base-selectbox-item';
import mcContainer from './components/base-container';
import mcLine from './components/base-line';
import mcRadio from './components/base-radio';
import mcRadioGroup from './components/base-radio-group';
import mcTitle from './components/base-title';
import mcTabs from './components/base-tabs';
import mcPane from './components/base-pane';
import mcAlert from './components/base-alert';
import mcTable from './components/table/table';
import mcTableColumn from './components/table/table-column';

import mcTips from './components/base-tips';

import mcCard from './components/card';
import mcCardPoker from './components/card-poker';
import mcCardBreadth from './components/card-breadth';

import mcRow from './components/layout-row';
import mcCol from './components/layout-col';

import Alert from './components/alert';

import mcLoading from './components/base-loading';
import mcListFold from './components/base-list-fold';
import mcListFoldItem from './components/base-list-fold-item';
import mcPanel from './components/base-panel';

import mcTree from './components/tree';
import mcCheckboxGroup from './components/base-checkbox-group';
import mcCheckbox from './components/base-checkbox';

import mcForm from './components/form.vue';
import mcFormItem from './components/form-item.vue';

import mcTag from './components/tag.vue';
import mcDatepicker from './components/datepicker/datePicker';
import mcTimepicker from './components/base-timepicker';

import frame from './mixins/frame';
import validator from './mixins/validator';
import ComExplorer from './lib/comExplorer';

import slots from './script/config.json';

//组件列表
const components = {
	mcBtn,
	mcBtnDropdown,
	mcBtnDropdownItem,
	mcInput,
	mcSwitch,
	mcSelect,
	mcScroll,
	mcSelectOption,
	mcSelectGroup,
	mcSelectFooter,
	mcSelectbox,
	mcSelectboxTabs,
	mcSelectboxItem,
	mcSelectboxPane,
	mcContainer,
	mcLine,
	mcRadio,
	mcRadioGroup,
	mcTitle,
	mcTabs,
	mcPane,
	mcAlert,
	mcTips,
	mcRow,
	mcCol,
	mcCardPoker,
	mcCardBreadth,
	mcLoading,
	mcListFold,
	mcListFoldItem,
	mcPanel,
	mcCard,
	mcTree,
	mcCheckbox,
	mcCheckboxGroup,
	mcForm,
	mcFormItem,
	mcTag,
	mcDatepicker,
	mcTimepicker,
	mcTable,
	mcTableColumn
};

//MC-UI 插件定义
const McUI = {
	...components
};

//安装Vue插件
const install = function (Vue) {
	if (install.installed) return;
	const ce = new ComExplorer(McUI, slots);

	//添加全局方法
	Vue.getComponentConfigs = ce.getProps.bind(ce);

	//添加组件
	Object.keys(McUI).forEach(key => {
		Vue.component(key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(), McUI[key]);
	});

	//添加混入
	Vue.mixin(frame);
	//添加实例方法
	Vue.prototype.$alert = Alert;
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
	install(window.Vue);
}


//最终
export default {
	version: process.env.VERSION,
	install,
	frame,
	...components
};

export {validator};


// WEBPACK FOOTER //
// ./src/index.js